"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_v__sim__and__device(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e1c7b0e2-3819-4913-bce0-cbe306b726be",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "v-sim-and-device-mid"), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,138.29a22.29,22.29,0,0,1-11.21,3.62H44.21a18.47,18.47,0,0,1-18.47-18.47l.41-54.67A18.47,18.47,0,0,1,44.62,50.29h62.63a18.47,18.47,0,0,1,18.47,18.47l.13,20.53",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,50.29l3.27-26.61a6.16,6.16,0,0,1,6.11-5.39H95a6.16,6.16,0,0,1,6.11,5.39L104,50.29",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,142.29l-3.27,26.61a6.16,6.16,0,0,1-6.11,5.39H57a6.16,6.16,0,0,1-6.11-5.39L48,142.29",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.84,168.14V96A6.16,6.16,0,0,1,124,89.87h25.58L166,106.29v61.84a6.16,6.16,0,0,1-6.16,6.16H124A6.16,6.16,0,0,1,117.84,168.14Z",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.89,126.29h7.79a3.92,3.92,0,0,1,3.89,3.95v23.68a3.92,3.92,0,0,1-3.89,3.95h-7.79a3.92,3.92,0,0,1-3.89-3.95V130.24A3.92,3.92,0,0,1,137.89,126.29Z",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.5
  }));
}

var _default = ic_v__sim__and__device;
exports.default = _default;